import request from '@/utils/request'

export function queryDevices(userid) {
  return request({
    url: `/device/user/${userid}`,
    method: 'get'
  })
}

export function queryBpInfos(devid) {
  return request({
    url: `/device/bmap/${devid}`,
    method: 'get'
  })
}

export function queryLatestGps(userid) {
  return request({
    url: `/device/gps/${userid}`,
    method: 'get'
  })
}

export function queryLatestStates(userid) {
  return request({
    url: `/device/gps/${userid}`,
    method: 'get'
  })
}
